import { call, put, takeLatest } from "redux-saga/effects";
import { paperDelete } from "../../../services/paper";

import {
  deletePaperStart,
  deletePaperSuccess,
  deletePaperFailure,
} from "../reducer";
import { successNotifier } from "../../../utils/helpers";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* deletePaper({ payload }) {
  const { id, callback } = payload;

  const response = yield call(paperDelete, id);
  const { success, raw, message, statusCode } = response;

  if (success) {
    yield put(deletePaperSuccess());
    successNotifier("Paper deleted successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(deletePaperFailure(message || raw?.error));
    networkErrorHandler(statusCode, message || raw?.error);
  }
}

export default function* onDeletePaper() {
  yield takeLatest(deletePaperStart.type, deletePaper);
}
